import React, { useEffect, useState } from "react";
import TableLastPayment from "../table/home/TableLastPayment";
import TableOutstand from "../table/home/TableOutstand";
import * as ProviderService from "../../services/ProviderService";
import { RingLoader } from "react-spinners";
import Cookies from "universal-cookie";
import moment from "moment-timezone";
import swal from "sweetalert";
import "moment/locale/es";
import { useNavigate } from "react-router-dom";
import { t } from "../../../translations";

export default function DetailedAccordion() {
  const columnsLastPayment = [
    { title: t("detailedAccordion.paymentDate"), field: "FAVIS" },
    { title: t("detailedAccordion.paymentDocument"), field: "DOCUP" },
    { title: t("detailedAccordion.totalAmount"), field: "VALTO" },
    { title: t("detailedAccordion.currency"), field: "WAERS" },
  ];
  const columnsOutstand = [
     { title: t("detailedAccordion.invoice"), field: "REF_DOC_NO" },
    { title: t("detailedAccordion.date"), field: "DOC_DATE" },
    { title: t("detailedAccordion.amount"), field: "LC_AMOUNT" },
    { title: t("detailedAccordion.currency"), field: "LOC_CURRCY" },
    /* { title: t("detailedAccordion.invoiceDescription"), field: "ITEM_TEXT" }, */
  ];

  const cookies = new Cookies();

  const [dataPayments, setDataPayments] = useState([]);
  const [dataInvoices, setDataInvoices] = useState([]);
  const [isLoadingPayments, setIsLoadingPayments] = useState(true);
  const [isLoadingOpenMatches, setIsLoadingOpenMatches] = useState(true);
  const [totalImportPayments, setTotalImportPayments] = useState("$0");
  const [totalImportInvoices, setTotalImportInvoices] = useState("$0");
  const navigate = useNavigate();

  const e_csap = cookies.get("e_csap");
  const society = cookies.get("society");

  useEffect(() => {
    const dataPayments = {
      Proveedor: e_csap,
      Sociedad: society,
    };
    ProviderService.consultaPagos(dataPayments)
      .then((response) => {
        if (response.error) {
          if (response.data.message === "Request failed with status code 500") {
          } else {
            swal({
              title: t("detailedAccordion.sessionExpired"),
              text: t("detailedAccordion.yourSessionHasExpired"),
              icon: "warning",
            });
            logOut();
          }
        } else {
          //First case: There are not payments
          let data1 = response.data["n0:PortalProveedoresDataResponse"];
          if (data1) {
            if (
              data1.consultaPagos === undefined ||
              data1.consultaPagos === "undefined" ||
              data1.consultaPagos === null
            ) {
              setDataPayments([]);
            } //Second case: There is only one payment
            else if (
              data1.consultaPagos.consultaPagos.length === undefined ||
              data1.consultaPagos.consultaPagos.length === "undefined" ||
              data1.consultaPagos.consultaPagos.length === null
            ) {
              data1 = [data1.consultaPagos.consultaPagos];
              fortmatPayments(data1);
            } else {
              // Third case: There are more than one payment
              fortmatPayments(data1.consultaPagos.consultaPagos);
            }
          } else {
            console.log(t("detailedAccordion.dataPayments"));
          }
          setIsLoadingPayments(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoadingPayments(false);
      });

    const dataInvoices = {
      Proveedor: e_csap,
      Sociedad: society,
    };
    ProviderService.consultaPartidasAbiertas(dataInvoices)
      .then((response) => {
        if (response.data.name === "Error") {
          if (response.data.message === "Request failed with status code 500") {
            setIsLoadingOpenMatches(false);
          } else {
            swal({
              title: t("detailedAccordion.sessionExpired"),
              text: t("detailedAccordion.yourSessionHasExpired"),
              icon: "warning",
            });
            logOut();
            setIsLoadingOpenMatches(false);
          }
        } else {
          //First case: There are not payments
          let data2 = response.data["n0:PortalProveedoresDataResponse"];
          if (data2) {
            if (
              data2.consultaPartidasAbiertas === undefined ||
              data2.consultaPartidasAbiertas === "undefined" ||
              data2.consultaPartidasAbiertas === null
            ) {
              setDataInvoices([]);
            } //Second case: There is only one payment
            else if (
              data2.consultaPartidasAbiertas.consultaPartidasAbiertas.length ===
                undefined ||
              data2.consultaPartidasAbiertas.consultaPartidasAbiertas.length ===
                "undefined" ||
              data2.consultaPartidasAbiertas.consultaPartidasAbiertas.length ===
                null
            ) {
              data2 = [data2.consultaPartidasAbiertas.consultaPartidasAbiertas];
              formatInvoices(data2);
            } else {
              // Third case: There are more than one payment
              formatInvoices(
                data2.consultaPartidasAbiertas.consultaPartidasAbiertas,
              );
            }
          } else {
            console.log(t("detailedAccordion.arrivedUndefined"));
          }
          setIsLoadingOpenMatches(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoadingOpenMatches(false);
      });
  }, []);

  const logOut = async () => {
    cookies.remove("e_csap");
    cookies.remove("user_portal");
    navigate("/");
  };

  const formatInvoices = (data) => {
    const numeroFormatter = new Intl.NumberFormat("es-CO", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    moment.tz.setDefault("America/Bogota");
    let data4 = data;
    let summary = 0.0;
    data4.forEach((element) => {
      const simbolo = element.LOC_CURRCY === "COP" ? "$" : "";

      if (!element.LC_AMOUNT) return;

      let valorOriginal = element.LC_AMOUNT.toString().trim();
      let esNegativo = valorOriginal.includes("-");
      let valorNumerico = Number(valorOriginal.replace("-", ""));

      //Calcular summary
      summary += esNegativo ? -valorNumerico : valorNumerico;

      let valorFormateado = numeroFormatter.format(valorNumerico);

      //Formatear valor mostrado
      element.LC_AMOUNT = esNegativo
        ? "-" + simbolo + valorFormateado
        : simbolo + valorFormateado;

      //Fecha
      element.DOC_DATE = moment(element.DOC_DATE)
        .tz("America/Bogota")
        .format("YYYY/MM/DD");

      //Referencia
      element.REF_DOC_NO = element.REF_DOC_NO
        ? element.REF_DOC_NO.replace("-", "_")
        : "";
    });

    //Formatear summary final
    const simboloSummary =
      data4.length > 0 && data4[0].LOC_CURRCY === "COP" ? "$" : "";

    const summaryFormateado =
      (summary < 0 ? "-" : "") +
      simboloSummary +
      numeroFormatter.format(Math.abs(summary));

    setTotalImportInvoices(summaryFormateado);
    setDataInvoices(data4);
  };

  const fortmatPayments = (data) => {
    const numeroFormatter = new Intl.NumberFormat("es-CO", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    moment.tz.setDefault("America/Bogota");
    let data2 = data;
    let summary = 0.0;
    data2.forEach((element) => {
      const simbolo = element.WAERS === "COP" ? "$" : "";
      if (!element.VALTO) return;
      let valorOriginal = element.VALTO.toString().trim();
      let esNegativo = valorOriginal.includes("-");
      let valorNumerico = Number(valorOriginal.replace("-", ""));

      //Calcular summary
      summary += esNegativo ? -valorNumerico : valorNumerico;

      let valorFormateado = numeroFormatter.format(valorNumerico);

      //Formatear valor
      element.VALTO = esNegativo
        ? "-" + simbolo + valorFormateado
        : simbolo + valorFormateado;

      //Fecha
      element.FAVIS = moment(element.FAVIS)
        .tz("America/Bogota")
        .format("YYYY/MM/DD");
    });

    //Formatear summary final
    const simboloSummary =
      data2.length > 0 && data2[0].WAERS === "COP" ? "$" : "";

    const summaryFormateado =
      (summary < 0 ? "-" : "") +
      simboloSummary +
      numeroFormatter.format(Math.abs(summary));

    setTotalImportPayments(summaryFormateado);
    setDataPayments(data2);
  };

  return (
    <div className="flex flex-col xl:flex-col lg:flex-col lg:flex sm:block md:block items-center">
      <div className="xl:w-9/12 lg:w-9/12 md:w-9/12 sm:w-9/12 w-9/12">
        <div className="w-full bg-blue-700 shadow-lg text-center justify-center items-center mx-4">
          <div className="inline-block align-middle">
            <p className="text-white font-Flama-Regular xl:text-lg lg:text-base sm:text-sm md:text-xs text-xs h-10 p-2">
              {t("detailedAccordion.paymentList")}
            </p>
          </div>
        </div>
        <div className="w-full border-2 mx-4 border-gray-600 mb-4">
          {isLoadingPayments ? (
            <div className="flex items-center justify-center flex-col">
              <RingLoader color="blue" size={100} />
              <div className="text-center mb-20 ">
                <label className="mb-20 text-blue-500 text-sm">
                  {t("detailedAccordion.loadingTable")}
                </label>
              </div>
            </div>
          ) : (
            <div className="p-4">
              <TableLastPayment
                columns={columnsLastPayment}
                data={dataPayments}
              ></TableLastPayment>
            </div>
          )}
        </div>
        <div className="w-full bg-blue-700 shadow-lg text-center justify-center items-center mx-4">
          <div className="inline-block align-middle">
            <p className="text-white font-Flama-Regular h-10 p-2">
              {t("detailedAccordion.totalAmountList")} {totalImportPayments}
            </p>
          </div>
        </div>
      </div>
      <div className="xl:w-9/12 lg:w-9/12 md:w-9/12 sm:w-9/12 w-9/12 mt-10">
        <div className="w-full bg-blue-700 shadow-lg text-center justify-center items-center mx-4">
          <div className="inline-block align-middle">
            <p className="text-white font-Flama-Regular xl:text-lg lg:text-base sm:text-sm md:text-xs text-xs h-10 p-2">
              {t("detailedAccordion.outstandingInvoices")}
            </p>
          </div>
        </div>
        <div className="w-full border-2 mx-4 border-gray-600 mb-4">
          {isLoadingOpenMatches ? (
            <div className="flex items-center justify-center flex-col">
              <RingLoader color="blue" size={100} />
              <div className="text-center mb-20 ">
                <label className="mb-20 text-blue-500 text-sm">
                  {t("detailedAccordion.loadingTable")}
                </label>
              </div>
            </div>
          ) : (
            <div className="p-4">
              <TableOutstand
                columns={columnsOutstand}
                data={dataInvoices}
              ></TableOutstand>
            </div>
          )}
        </div>
        <div className="w-full bg-blue-700 shadow-lg text-center justify-center items-center mx-4">
          <div className="inline-block align-middle">
            <p className="text-white font-Flama-Regular h-10 p-2">
              {t("detailedAccordion.totalAmountInvoices")} {totalImportInvoices}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
